import { $api } from 'api/http'
import { IFilterParams, IFilters } from 'api/types/filter'

class FilterApiService {
  getFilters({ id, search, filters }: IFilterParams) {
    return $api.post<IFilters>(`/filters/${id}`, {
      filters,
      search,
    })
  }
}

export const filterApiService = new FilterApiService()
